export const GET_METRICS = 'GET_METRICS';
export const CLEAR_METRICS = 'CLEAR_METRICS';
export const GET_DASHBOARD_SETTINGS = 'GET_DASHBOARD_SETTINGS';

export const SAVE_WIDGET = 'SAVE_WIDGET';
export const LIST_WIDGET = 'LIST_WIDGET';
export const GET_METRICS_SETTINGS = 'GET_METRICS_SETTINGS';